export const hasCoachingPlanAccess = (ownerId) => {
  return process.env.REACT_APP_THEME === 'AVATAR' && ownerId === 42
}

export const hasExerciseAccess = (user, account) => {
  return hasCoachingPlanAccess(user?.owner_id) && account?.has_exercise === true
}
